import { add, isNil } from 'lodash';

export const CHECK_BOTH_YEARS = {};
export const CHECK_CURRENT_YEAR_ONLY = {};

// checking whether the IRA funds has at least $1000 to add a new fund
export const disableIRAFunds = (IRALimitData, personalData) => {
  if (isNil(IRALimitData) || isNil(personalData)) {
    return false;
  }

  // Needs to be returned along with IRALimitData from service
  const newFundRegistrationContributionLimit = 1000;
  const {
    currentYearMaximumLimit,
    currentYearContributionsSoFar,
    currentYearRemainingContributions,
    priorYearMaximumLimit,
    priorYearContributionsSoFar,
    priorYearRemainingContributions,
    withinIRAPriorYearContributionPeriod,
  } = IRALimitData;

  if (withinIRAPriorYearContributionPeriod) {
    const canStillContributeToAtleastOneYear =
      currentYearContributionsSoFar < currentYearMaximumLimit ||
      priorYearContributionsSoFar < priorYearMaximumLimit;
    const meetsNewFundRegistrationContributionLimit =
      add(currentYearRemainingContributions, priorYearRemainingContributions) >=
      newFundRegistrationContributionLimit;

    if (
      !canStillContributeToAtleastOneYear ||
      !meetsNewFundRegistrationContributionLimit
    ) {
      return true;
    }
  } else {
    const canStillContributeCurrentYear =
      currentYearContributionsSoFar < currentYearMaximumLimit;
    const meetsNewFundRegistrationContributionLimit =
      currentYearRemainingContributions >= newFundRegistrationContributionLimit;

    if (
      !canStillContributeCurrentYear ||
      !meetsNewFundRegistrationContributionLimit
    ) {
      return true;
    }
  }
  return false;
};

export const isIRA = (fundVal) => {
  return fundVal.agreementType.toUpperCase().includes('IRA');
};

export const isRMDEligibleCheck = (personalData, agreementType) => {
  if (agreementType !== 'ROLLOVER_IRA' && agreementType !== 'TRADITIONAL_IRA') {
    return false;
  }
  return personalData.eligibleForRMD;
};
